export default __webpack_public_path__ + "static/media/image-plan2.92317a91.png";